export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8524.18e6e586.jpg";